import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ProcessSchema } from '../../entities/process/process.schema';
import { ErrorCode } from '../../shared/error-codes';
/**
 * Duplicate Process Request Schema
 * POST /api/v2/process/:id/duplicate
 *
 * The source process id is carried in the path; the body carries the name of
 * the new process. Everything else is copied from the source.
 */ export const DuplicateProcessRequestSchema = z.object({
    name: z.string().min(1, ErrorCode.FIELD_REQUIRED)
});
/**
 * Duplicate Process Response Schema
 * Returned on successful duplication
 * Contains the newly created process object (the copy), not the source.
 */ export const DuplicateProcessResponseSchema = z.object({
    process: ProcessSchema
});
/**
 * Duplicate Process Error Schema
 * Returned when process duplication fails
 */ export const DuplicateProcessErrorSchema = BaseErrorSchema;

//# sourceMappingURL=duplicate-process.schema.js.map